module.exports = __webpack_public_path__ + "static/media/05_negro.13b05e63.svg";